import { TypeFacturation } from "../../common/models/type.facturation";
import { ExchangeFile } from "./exchange-file";

export class ADAPTE {

    public facturation: TypeFacturation;
    public textArea: string;
    public logo: ExchangeFile;


    constructor() {
        this.facturation = new TypeFacturation();
    }

}